export default __webpack_public_path__ + "static/media/n9.9af9b87c.jpg";